import i18next from 'i18next';
import {
  IAccessRightsNumbers,
  IHiikoEnvironmentAdministrationView,
  PermissionsEnum,
} from './types';

export const getPermissionNumbersFromBooleans = (
  permissions:
    | null
    | ({ [key: string]: any } & IHiikoEnvironmentAdministrationView),
): IAccessRightsNumbers => {
  const defaultPermissions = {
    companyAdministrationRead: false,
    companyAdministrationWrite: false,

    cultureAdministrationRead: false,
    cultureAdministrationWrite: false,

    fieldAdministrationRead: false,
    fieldAdministrationWrite: false,

    resourceAdministrationRead: false,
    resourceAdministrationWrite: false,

    taskAdministrationRead: false,
    taskAdministrationWrite: false,

    recommendationPermission: false,

    usersAdministrationRead: false,
    usersAdministrationWrite: false,

    garageAdministrationRead: false,
    garageAdministrationWrite: false,

    analyticsPermission: false,
  };

  const p = permissions || defaultPermissions;
  return {
    companyAdministration:
      p.companyAdministrationRead && p.companyAdministrationWrite
        ? 2
        : p.companyAdministrationRead
        ? 1
        : 0,

    cultureAdministration:
      p.cultureAdministrationRead && p.cultureAdministrationWrite
        ? 2
        : p.cultureAdministrationRead
        ? 1
        : 0,
    fieldAdministration:
      p.fieldAdministrationRead && p.fieldAdministrationWrite
        ? 2
        : p.fieldAdministrationRead
        ? 1
        : 0,

    resourceAdministration:
      p.resourceAdministrationRead && p.resourceAdministrationWrite
        ? 2
        : p.resourceAdministrationRead
        ? 1
        : 0,
    taskAdministration:
      p.taskAdministrationRead && p.taskAdministrationWrite
        ? 2
        : p.taskAdministrationRead
        ? 1
        : 0,
    recommendationPermission: p.recommendationPermission ? 2 : 0,

    usersAdministration:
      p.usersAdministrationRead && p.usersAdministrationWrite
        ? 2
        : p.usersAdministrationRead
        ? 1
        : 0,

    garageAdministration:
      p.garageAdministrationRead && p.garageAdministrationWrite
        ? 2
        : p.garageAdministrationRead
        ? 1
        : 0,
    analytics: p.analyticsPermission ? 1 : 0,
  };
};

export const getPermissionsBooleansFromNumbers = (
  permissions: IAccessRightsNumbers,
): IHiikoEnvironmentAdministrationView => {
  return {
    companyAdministrationRead: permissions.companyAdministration > 0,
    companyAdministrationWrite: permissions.companyAdministration > 1,

    cultureAdministrationRead: permissions.cultureAdministration > 0,
    cultureAdministrationWrite: permissions.cultureAdministration > 1,

    fieldAdministrationRead: permissions.fieldAdministration > 0,
    fieldAdministrationWrite: permissions.fieldAdministration > 1,

    resourceAdministrationRead: permissions.resourceAdministration > 0,
    resourceAdministrationWrite: permissions.resourceAdministration > 1,

    taskAdministrationRead: permissions.taskAdministration > 0,
    taskAdministrationWrite: permissions.taskAdministration > 1,

    recommendationPermission: permissions.recommendationPermission > 0,

    usersAdministrationRead: permissions.usersAdministration > 0,
    usersAdministrationWrite: permissions.usersAdministration > 1,

    garageAdministrationRead: permissions.garageAdministration > 0,
    garageAdministrationWrite: permissions.garageAdministration > 1,

    analyticsPermission: permissions.analytics > 0,
  };
};

export const getPermissionCheckboxes = () => {
  const checkboxesRows = [
    {
      label: i18next.t(
        'User.AddUserForm.FieldAdministration',
        'Field administration',
      ),
      name: PermissionsEnum.fieldAdministration,
    },
    {
      label: i18next.t(
        'User.AddUserForm.TaskAdministration',
        'Task administration',
      ),
      name: PermissionsEnum.taskAdministration,
      requiredPermissions: [
        i18next.t(
          'User.AddUserForm.FieldAdministration',
          'Field administration',
        ),
      ],
    },
    {
      label: i18next.t(
        'User.AddUserForm.ResourceAdministration',
        'Resource administration',
      ),
      name: PermissionsEnum.resourceAdministration,
      requiredPermissions: [
        i18next.t(
          'User.AddUserForm.FieldAdministration',
          'Field administration',
        ),
      ],
    },
    {
      label: i18next.t(
        'User.AddUserForm.CultureAdministration',
        'Culture administration',
      ),
      name: PermissionsEnum.cultureAdministration,
      requiredPermissions: [
        i18next.t(
          'User.AddUserForm.FieldAdministration',
          'Field administration',
        ),
      ],
    },
    {
      label: i18next.t(
        'User.AddUserForm.CompanyAdministration',
        'Company administration',
      ),
      name: PermissionsEnum.companyAdministration,
    },
    {
      label: i18next.t(
        'User.AddUserForm.usersAdministration',
        'User administration',
      ),
      name: PermissionsEnum.usersAdministration,
    },
    {
      label: i18next.t(
        'User.AddUserForm.GarageAdministration',
        'Garage administration',
      ),
      name: PermissionsEnum.garageAdministration,
    },
    {
      label: i18next.t(
        'User.AddUserForm.RecommendationAdministration',
        'Recommendation administration',
      ),
      name: PermissionsEnum.recommendationPermission,
      isVieWDisabled: true,
      requiredPermissions: [
        i18next.t(
          'User.AddUserForm.FieldAdministration',
          'Field administration',
        ),
        i18next.t('User.AddUserForm.TaskAdministration', 'Task administration'),
      ],
    },
    {
      label: i18next.t('User.AddUserForm.Analytics', 'Analytics'),
      name: PermissionsEnum.analytics,
      isEditDisabled: true,
    },
  ];
  return checkboxesRows;
};
